import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import SpinnerButton from "../../components/Button";
import { SpinnerButtonPrimary } from "../../ui/buttons";

function ConfirmarMensajeModal({ toggle, handleSubmitMessage }) {
  return (
    <Modal centered backdrop="static" isOpen toggle={toggle}>
      <div style={{ fontFamily: "Nunito" }}>
        <ModalHeader className="border-0" toggle={toggle} />

        <ModalBody>
          <p className="mb-1" style={{ fontSize: "18px", fontWeight: "normal" }}>
            Este mensaje sera enviado al usuario solicitante,
          </p>
          <p className="mb-1" style={{ fontSize: "18px", fontWeight: "bold" }}>
            ¿Desea continuar?
          </p>
        </ModalBody>
        <ModalFooter className="border-0">
          <div className="mb-0 px-3 w-100 d-flex justify-content-end">
            <SpinnerButton className="btn btn-light mr-2" type="button" onClick={toggle}>
              Cancelar
            </SpinnerButton>
            <SpinnerButtonPrimary type="button" onClick={handleSubmitMessage}>
              Confirmar
            </SpinnerButtonPrimary>
          </div>
        </ModalFooter>
      </div>
    </Modal>
  );
}

export default ConfirmarMensajeModal;
